import { Grid } from "@mui/material";
import { Formik } from "formik";
import React from "react";
import PTButton from "./PTButton";

export const PTForm = ({
  name,
  onSubmit,
  initialValues = {},
  submitButtonText = "Submit",
  retablireButtonText = "Retablir",
  onRetablire,
  retableOn = true,
  submitOn = true,
  validationSchema,
  formRef,
  enableReinitialize = true,
  children,
  buttonStyle,
  fullWidthSubmitButton = false,
  isPending,
  onRetour = null
}) => {
  if (!name) throw new Error("name is required for FORM");
  const localRef = React.useRef();
  const innerRef = formRef || localRef;
  const handleFormSubmit = async (values, { setSubmitting }) => {
    try {
      const data = {
        ...innerRef?.current?.values,
        ...values,
      };
      await onSubmit(data);
      setSubmitting(false);
    } catch (error) {
      //showAlert("error", error.message);
      setSubmitting(false);
    }
  };

  const handleRetablire = () => {
    innerRef.current.resetForm();
    if (onRetablire) onRetablire(innerRef);
  };

  const formValidation = (values) => {
    if(!validationSchema) return {};
    const selectedSchema = validationSchema;
    try {
      selectedSchema.validateSync(values, {
        abortEarly: false,
      });
      return {};
    } catch (error) {
      const formattedErrors = {};
      error.inner.forEach((err) => {
        const path = err.path;
        const message = err.message;
        formattedErrors[path] = message;
      });
      console.error("formattedErrors", formattedErrors);
      return formattedErrors;
    }
  };
  return (
    <Formik
      innerRef={innerRef}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleFormSubmit}
      enableReinitialize={enableReinitialize}
      validate={formValidation}
    >
      {({ handleSubmit, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {React.Children.map(children, (child) =>
              React.cloneElement(child, { formName: name, formRef: innerRef })
            )}
            {(submitOn || retableOn) && (
              <Grid item xs={12}>
                <Grid container justifyContent="flex-end" spacing={1}>
                  {
                    onRetour && (
                      <Grid item>
                        <PTButton
                          title="Retour"
                          color="primary"
                          fullWidth
                          onClick={onRetour}
                        />
                      </Grid>
                    )
                  }
                  {retableOn && (
                    <Grid item>
                      <PTButton
                        title={retablireButtonText}
                        color="primary"
                        fullWidth
                        onClick={handleRetablire}
                      />
                    </Grid>
                  )}
                  {submitOn && (
                    <Grid item xs={fullWidthSubmitButton ? 12 : 0}>
                      <PTButton
                        title={submitButtonText}
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        handleSubmit={handleSubmit}
                        disabled={isPending ? isPending : isSubmitting}
                        sx={{
                          ...(buttonStyle || {}),
                        }}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            )}
          </Grid>
        </form>
      )}
    </Formik>
  );
};
